import { render, staticRenderFns } from "./ClientSponsorshipTable.vue?vue&type=template&id=9c5b8e94"
import script from "./ClientSponsorshipTable.vue?vue&type=script&lang=js"
export * from "./ClientSponsorshipTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports